import qs from 'qs'
import { ELEMENT_KEYS_MAP, ELEMENT_KEYS_MAP_BOOT } from '../../../component/filter/element/element'

const getConfig = (gender) => {
  if (gender === '鞋靴') {
    const LEVELS = [
      ELEMENT_KEYS_MAP_BOOT.craft,
      ELEMENT_KEYS_MAP_BOOT.heel,
      ELEMENT_KEYS_MAP_BOOT.shoelace,
      ELEMENT_KEYS_MAP_BOOT.upper,
      ELEMENT_KEYS_MAP_BOOT.toe,
      ELEMENT_KEYS_MAP_BOOT.shoes,
      ELEMENT_KEYS_MAP_BOOT.tube,
    ]
    return {
      hasBoot: true,
      LEVELS,
      CONFIG_ELEMENT_KEYS_MAP: ELEMENT_KEYS_MAP_BOOT
    }
  }
  const LEVELS = [ELEMENT_KEYS_MAP.design, ELEMENT_KEYS_MAP.craft, ELEMENT_KEYS_MAP.accessories, ELEMENT_KEYS_MAP.collarType]
  return {
    hasBoot: false,
    LEVELS,
    CONFIG_ELEMENT_KEYS_MAP: ELEMENT_KEYS_MAP
  }
}

const useStyleFilterQueryParams = () => {
  const query:any = qs.parse(location.search, { ignoreQueryPrefix: true })
  const queryParams :any = {
    userIdList: query.userIdList ? [Number(query.userIdList)] : undefined,
    markStatus: query.markStatus,
    markTimes: query.markTimes,
    createdTimeStart: query.createdTimeStart,
    createdTimeEnd: query.createdTimeEnd,
  }

  if (query.prices) {
    if (query.prices.indexOf('以上') !== -1) {
      const index = query.prices.indexOf('以上')
      const _priceStart = query.prices.substring(0, index)
      queryParams.priceStart = _priceStart
      queryParams.priceEnd = null
    } else {
      const _prices = query.prices.split('~')
      queryParams.priceStart = _prices[0]
      queryParams.priceEnd = _prices[1]
    }
  }
  if (query.gender) {
    const { LEVELS, CONFIG_ELEMENT_KEYS_MAP, hasBoot } = getConfig(query.gender)
    queryParams.gender = query.gender
    queryParams.category = query.category
    const maps = Object.keys(CONFIG_ELEMENT_KEYS_MAP)
    const curElement = Object.keys(query).filter(item => maps.includes(item))
    if (curElement.length) {
      queryParams.element = {}
      if (CONFIG_ELEMENT_KEYS_MAP[curElement[0]] === CONFIG_ELEMENT_KEYS_MAP.fabric && !hasBoot) { // 单独处理设计要素面料
        queryParams.element[ELEMENT_KEYS_MAP[curElement[0]]] = { root: ELEMENT_KEYS_MAP[curElement[1]], child: query[curElement[1]] }
      } else if (LEVELS.includes(CONFIG_ELEMENT_KEYS_MAP[curElement[0]])) { //
        const _ele = query[curElement[0]].split(',')
        if (_ele[1]) {
          queryParams.element[CONFIG_ELEMENT_KEYS_MAP[curElement[0]]] = { root: _ele[1], child: _ele[0] }
        } else {
          queryParams.element[CONFIG_ELEMENT_KEYS_MAP[curElement[0]]] = { root: _ele[0], child: null }
        }
      } else {
        queryParams.element[CONFIG_ELEMENT_KEYS_MAP[curElement[0]]] = { root: query[curElement[0]], child: null }
      }
    }
  }
  return queryParams
}

export default useStyleFilterQueryParams
